export default {
  name: 'templates',
  translationKey: 'templates-module',
  routePrefix: 'templates',
  routeNamePrefix: 'admin.templates',
  directRoutesAvailable: false,
}
